import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { afterNextRender, Component, inject, PLATFORM_ID } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Subject } from 'rxjs';
import { ModalService } from '../../services/modal/modal.service';

export const MODAL_CONFIRM = 'confirm';

@Component({
  selector: 'app-modal-basement',
  template: '',
})
export class ModalBasement<T = any> {
  public readonly modalService = inject(ModalService);
  public readonly platformId = inject(PLATFORM_ID);
  public readonly dialogRef = inject(DialogRef);

  private readonly _props = inject(DIALOG_DATA);

  props$ = new Subject<T>();
  props = toSignal(this.props$);

  constructor() {
    afterNextRender(() => {
      this.props$.next(this._props);
    });
  }

  close(ev?: any): void {
    const element = this.modalService.getElement();
    if (element) {
      const closeAnimation = element.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 200,
        easing: 'ease-in-out',
      });
      closeAnimation!.onfinish = () => {
        this.dialogRef.close(ev);
      };
    }
  }

  confirm(event?: Event): void {
    event?.stopPropagation();
    event?.preventDefault();

    const element = this.modalService.getElement();
    if (element) {
      const closeAnimation = element.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 200,
        easing: 'ease-in-out',
      });
      closeAnimation!.onfinish = () => {
        this.dialogRef.close(MODAL_CONFIRM);
      };
    }
  }
}
